module.exports = __webpack_public_path__ + "img/ud_data_report.9e740877.svg";